import { defaults } from './defaults';
import PlayerPitcherMatchupModel from '../models/PlayerPitcherMatchupModel';

export default {
    ...defaults,
    model: PlayerPitcherMatchupModel,
    pathTemplate: 'api/v1/people/{batterId}?hydrate=stats(group=batting,type=vsPlayerTotal,opposingPlayerId={pitcherId},season={season})',
    expires: 9
};
